export default "__VITE_ASSET__DpKqCwdE__"